import { apiClient } from "@config/apiClient";
import { API_URL } from "@config/constants";
import { IBatchRelationsBody, IRelationResponse } from "@interfaces/relation.interface";
import { ITagResponse } from "@interfaces/responses.interface";
import { OptionsForTags } from "@interfaces/tag.interface";

class RelationService {
  private URL = `${API_URL}/common/relations`;

  async getCurrentTags(contentType: string, objectId: string): Promise<ITagResponse[]> {
    return apiClient.get(
      `${this.URL}/object-tags/?content_type=${contentType}&object_id=${objectId}&relation_type=`
    );
  }

  async getDiscussedTopics(contentType: string, objectId: string): Promise<ITagResponse[]> {
    return apiClient.get(
      `${this.URL}/object-tags/?content_type=${contentType}&object_id=${objectId}&relation_type=discussed_topic`
    );
  }

  async getTaggingOptions(params: string): Promise<OptionsForTags> {
    return apiClient.get(`${this.URL}/tagging-options/${params}`);
  }

  async getSuggestedTags(contentType: string, objectId: string): Promise<OptionsForTags> {
    return apiClient.get(
      `${this.URL}/suggestions/?content_type=${contentType}&object_id=${objectId}`
    );
  }

  async addTag(data: object): Promise<IRelationResponse> {
    return apiClient.post(`${this.URL}/`, data);
  }

  async addBatchTags(data: IBatchRelationsBody): Promise<any> {
    return apiClient.post(`${this.URL}/batch/`, data);
  }

  async deleteTag(tagId: string): Promise<IRelationResponse> {
    return apiClient.delete(`${this.URL}/${tagId}/`);
  }
}

const relationService = new RelationService();
export default relationService;
